export default function toCamelCase(string, separator = '_') {
    return string.split(separator).map((word, index) => {
        if (index === 0) {
            return word.toLowerCase();
        }

        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join('');
}
